import type { RouteRecordRaw } from 'vue-router';

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: "/home",
    redirect: "/home/dashboard/",
  },
  {
    path: "/home/dashboard/",
    name: "HomeDashboard",
    component: () => import("@/views/home/dashboard/Dashboard.vue"),
    props: {
      actionPermissions: [],
      viewPermissions: ["dashboard-read", "dashboard-all"],
      extraPermissions: [
        "connectioninvite-write",
        "sku-write",
        "extractkeys-write",
        "insertkeys-write",
        "transferkeys-write",
        "report-write",
        "extractrevokedkeys-write",
        "extractinventorykeys-write",
        "reportfinance-write",
        "reportkeybykey-write",
      ],
    },
    meta: {
      title: "Home",
      requiresAuth: true,
      navigation: {
        label: 'Dashboard',
        icon: 'pie-icon.svg',
        order: 1,
        showInMenu: true,
        permissions: {
          rbacRoles: [
            "dashboardnav-read"
          ],
          ownerRoles: ['Publisher', 'Retailer'],
          viewPermissions: ['dashboard-read', 'dashboard-all']
        }
      }
    },
  },
];